
import { ElForm, ElMessage, ElMessageBox, ElLoading } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import UploadFormItem from '@/components/form/common/UploadFormItem.vue'
import {
  ApplicationVersionModel,
  ApplicationVersionPageSearchModel,
  ApplicationVersionSearchModel,
  ApplicationVersionAddModel,
  ApplicationVersionUpdateModel,
  IdsModel
} from '@/model/product/ApplicationVersionModel'
import {
  pageSearchApplicationVersion,
  addApplicationVersion,
  updateApplicationVersion,
  removeApplicationVersion,
  batchRemoveApplicationVersion
} from '@/apis/product/applicationVersion'
import { ApplicationSearchModel } from '@/model/product/ApplicationModel'
import { searchApplication } from '@/apis/product/application'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store'
import networkConfig from '@/config/default/net.config'
import { Route } from '@/constant/route'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    UploadFormItem,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const createUpload = ref()
    const searchStruct = [
      // { prop: 'appId', label: t('applicationVersion.appId'), placeholder: t('applicationVersion.appIdP'), component: 'el-input', type: 'number', model: null },
      { prop: 'appName', label: t('applicationVersion.appName'), placeholder: t('applicationVersion.appNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'releaseVersion', label: t('applicationVersion.releaseVersion'), placeholder: t('applicationVersion.releaseVersionP'), component: 'el-input', type: 'text', model: null },
      { prop: 'releaseDate', label: t('applicationVersion.releaseDate'), placeholder: t('applicationVersion.releaseDateP'), component: 'el-input', type: 'date', model: null }
      // { prop: 'isAndroidApp', label: t('applicationVersion.isAndroidApp'), placeholder: t('applicationVersion.isAndroidAppP'), component: 'el-select', type: 'text', model: null, options: [{ label: t('applicationVersion.isAndroidAppTrue'), value: true }, { label: t('applicationVersion.isAndroidAppFalse'), value: false }] },
      // { prop: 'thirdPartyStore', label: t('applicationVersion.thirdPartyStore'), placeholder: t('applicationVersion.thirdPartyStoreP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'thirdPartyWebsite', label: t('applicationVersion.thirdPartyWebsite'), placeholder: t('applicationVersion.thirdPartyWebsiteP'), component: 'el-input', type: 'text', model: null }
    ]

    const createStruct = [
      // { prop: 'appId', label: t('applicationVersion.appId'), placeholder: t('applicationVersion.appIdP'), component: 'el-input', type: 'number', model: null },
      {
        prop: 'appId',
        label: t('applicationVersion.appName'),
        placeholder: t('applicationVersion.appNameP'),
        component: 'el-select',
        model: '',
        filterable: true,
        remote: true,
        loading: false,
        remoteMethod: async(query: string) => { console.log(query) },
        options: [] as any
      },
      { prop: 'releaseVersion', label: t('applicationVersion.releaseVersion'), placeholder: t('applicationVersion.releaseVersionP'), component: 'el-input', type: 'text', model: null },
      { prop: 'releaseDate', label: t('applicationVersion.releaseDate'), placeholder: t('applicationVersion.releaseDateP'), component: 'el-input', type: 'datetime-local', model: null },
      { prop: 'isAndroidApp', label: t('applicationVersion.isAndroidApp'), placeholder: t('applicationVersion.isAndroidAppP'), component: 'el-select', type: 'text', model: null, options: [{ label: t('applicationVersion.isAndroidAppTrue'), value: true }, { label: t('applicationVersion.isAndroidAppFalse'), value: false }] }
      // { prop: 'thirdPartyStore', label: t('applicationVersion.thirdPartyStore'), placeholder: t('applicationVersion.thirdPartyStoreP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'thirdPartyWebsite', label: t('applicationVersion.thirdPartyWebsite'), placeholder: t('applicationVersion.thirdPartyWebsiteP'), component: 'el-input', type: 'text', model: null }
    ]

    const updateStruct = [
      // { prop: 'appId', label: t('applicationVersion.appId'), placeholder: t('applicationVersion.appIdP'), component: 'el-input', type: 'number', model: null },
      { prop: 'appName', label: t('applicationVersion.appName'), placeholder: t('applicationVersion.appNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'releaseVersion', label: t('applicationVersion.releaseVersion'), placeholder: t('applicationVersion.releaseVersionP'), component: 'el-input', type: 'text', model: null },
      { prop: 'releaseDate', label: t('applicationVersion.releaseDate'), placeholder: t('applicationVersion.releaseDateP'), component: 'el-input', type: 'datetime', model: null },
      { prop: 'isAndroidApp', label: t('applicationVersion.isAndroidApp'), placeholder: t('applicationVersion.isAndroidAppP'), component: 'el-select', type: 'text', model: null, options: [{ label: t('applicationVersion.isAndroidAppTrue'), value: true }, { label: t('applicationVersion.isAndroidAppFalse'), value: false }] }
      // { prop: 'thirdPartyStore', label: t('applicationVersion.thirdPartyStore'), placeholder: t('applicationVersion.thirdPartyStoreP'), component: 'el-input', type: 'text', model: null },
      // { prop: 'thirdPartyWebsite', label: t('applicationVersion.thirdPartyWebsite'), placeholder: t('applicationVersion.thirdPartyWebsiteP'), component: 'el-input', type: 'text', model: null }
    ]

    const applicationVersionRole = {
      appId: [{ required: true, message: t('applicationVersion.appId').concat(t('common.isRequired')), trigger: 'blur' }],
      appName: [{ required: true, message: t('applicationVersion.appName').concat(t('common.isRequired')), trigger: 'blur' }],
      releaseVersion: [{ required: true, message: t('applicationVersion.releaseVersion').concat(t('common.isRequired')), trigger: 'blur' }],
      releaseDate: [{ required: true, message: t('applicationVersion.releaseDate').concat(t('common.isRequired')), trigger: 'blur' }],
      isAndroidApp: [{ required: true, message: t('applicationVersion.isAndroidApp').concat(t('common.isRequired')), trigger: 'blur' }]
      // thirdPartyStore: [{ required: true, message: t('applicationVersion.thirdPartyStore').concat(t('common.isRequired')), trigger: 'blur' }],
      // thirdPartyWebsite: [{ required: true, message: t('applicationVersion.thirdPartyWebsite').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      // { prop: 'appId', label: t('applicationVersion.appId'), sortable: 'custom' },
      { prop: 'appName', label: t('applicationVersion.appName'), sortable: 'custom' },
      { prop: 'releaseVersion', label: t('applicationVersion.releaseVersion'), sortable: 'custom' },
      { prop: 'releaseDate', label: t('applicationVersion.releaseDate'), formatter: (row: ApplicationVersionModel) => { return parseTime(row.releaseDate) }, sortable: 'custom' },
      { prop: 'isAndroidApp', label: t('applicationVersion.isAndroidApp'), formatter: (row: ApplicationVersionModel) => { return row.isAndroidApp ? t('applicationVersion.isAndroidAppTrue') : t('applicationVersion.isAndroidAppFalse') }, sortable: 'custom' }
      // { prop: 'thirdPartyStore', label: t('applicationVersion.thirdPartyStore'), sortable: 'custom' },
      // { prop: 'thirdPartyWebsite', label: t('applicationVersion.thirdPartyWebsite'), sortable: 'custom' }
      // { prop: 'createTime', label: t('common.createTime'), formatter: (row: ApplicationVersionModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      // { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: ApplicationVersionModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as ApplicationVersionSearchModel,
      tableData: Array<ApplicationVersionModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'applicationVersion.edit',
        create: 'applicationVersion.create'
      },
      dialogFormVisible: false,
      applicationVersionRole: applicationVersionRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as ApplicationVersionAddModel,
      uploadPackageModel: {} as any,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as ApplicationVersionUpdateModel,
      editRow: {} as ApplicationVersionModel,
      loadingUpload: null as any,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: ApplicationVersionPageSearchModel = {
          appId: dataMap.searchFormModel.appId,
          appName: dataMap.searchFormModel.appName,
          releaseVersion: dataMap.searchFormModel.releaseVersion,
          releaseDate: dataMap.searchFormModel.releaseDate ? dataMap.searchFormModel.releaseDate + ' 00:00:00' : null,
          isAndroidApp: dataMap.searchFormModel.isAndroidApp,
          thirdPartyStore: dataMap.searchFormModel.thirdPartyStore,
          thirdPartyWebsite: dataMap.searchFormModel.thirdPartyWebsite,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchApplicationVersion(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        const createData: ApplicationVersionAddModel = {
          appId: dataMap.createModel.appId,
          appName: dataMap.createModel.appName,
          releaseVersion: dataMap.createModel.releaseVersion,
          releaseDate: dataMap.createModel.releaseDate,
          isAndroidApp: dataMap.createModel.isAndroidApp,
          thirdPartyStore: '', // dataMap.createModel.thirdPartyStore,
          thirdPartyWebsite: '' // dataMap.createModel.thirdPartyWebsite
        }
        const result = await addApplicationVersion(createData)

        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          if (createUpload.value.validateUpload(true)) {
            ElMessage({
              message: t('common.createSuccess'),
              type: 'success',
              duration: 2000
            })
            return
          }
          dataMap.uploadPackageModel.version = createData.releaseVersion
          dataMap.uploadPackageModel.id = createData.appId
          dataMap.loadingUpload = ElLoading.service({
            lock: true,
            text: t('common.uploading'),
            background: 'rgba(0, 0, 0, 0.7)'
          })
          await createUpload.value.submitUpload()
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async updateNameSubmit() {
        const updateData: ApplicationVersionUpdateModel = {
          id: dataMap.updateModel.id,
          appId: dataMap.updateModel.appId,
          appName: dataMap.updateModel.appName,
          releaseVersion: dataMap.updateModel.releaseVersion,
          releaseDate: dataMap.updateModel.releaseDate,
          isAndroidApp: dataMap.updateModel.isAndroidApp,
          thirdPartyStore: dataMap.updateModel.thirdPartyStore,
          thirdPartyWebsite: dataMap.updateModel.thirdPartyWebsite
        }
        const result = await updateApplicationVersion(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeApplicationVersion(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveApplicationVersion(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.appId = dataMap.editRow.appId
        dataMap.updateModel.appName = dataMap.editRow.appName
        dataMap.updateModel.releaseVersion = dataMap.editRow.releaseVersion
        dataMap.updateModel.releaseDate = dataMap.editRow.releaseDate
        dataMap.updateModel.isAndroidApp = dataMap.editRow.isAndroidApp
        dataMap.updateModel.thirdPartyStore = dataMap.editRow.thirdPartyStore
        dataMap.updateModel.thirdPartyWebsite = dataMap.editRow.thirdPartyWebsite
      },
      createReset() {
        console.log('create reset')
        if (createUpload.value) {
          createUpload.value.onReset()
        }
      }
    })
    const getApplicationOptions = async(query: string) => {
      dataMap.createStruct[0].loading = true
      const params: ApplicationSearchModel = {
        appName: query,
        appDescription: null,
        partnerNumber: null,
        minVersion: null,
        currentVersion: null,
        packageAddress: null
      }
      const data = await searchApplication(params)
      const list = data?.data ?? []
      const optionList = []
      for (const iterator of list) {
        optionList.push({ label: iterator.appName, value: iterator.id })
      }
      dataMap.createStruct[0].options = optionList
      dataMap.createStruct[0].loading = false
    }
    const handleCreate = () => {
      dataMap.dialogStatus = 'create'
      if (createUpload.value) {
        createUpload.value.onReset()
      }
      getApplicationOptions('')
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: ApplicationVersionModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.appId = row.appId
        dataMap.updateModel.appName = row.appName
        dataMap.updateModel.releaseVersion = row.releaseVersion
        dataMap.updateModel.releaseDate = row.releaseDate
        dataMap.updateModel.isAndroidApp = row.isAndroidApp
        dataMap.updateModel.thirdPartyStore = row.thirdPartyStore
        dataMap.updateModel.thirdPartyWebsite = row.thirdPartyWebsite
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleUpload = (result: any) => {
      console.log(result)
      if (dataMap.loadingUpload) {
        dataMap.loadingUpload.close()
      }
      if (result?.code === 0) {
        ElMessage({
          message: t('common.createSuccess'),
          type: 'success',
          duration: 2000
        })
      } else {
        ElMessage({
          message: result?.message,
          type: 'error',
          duration: 2000
        })
      }
    }
    const getUploadUri = () => {
      return networkConfig.host + Route.product + '/application/update/package'
    }
    const getUploadHeader = () => {
      return {
        Authorization: 'Bearer ' + useStore().state.user.token
      }
    }
    onMounted(() => {
      dataMap.createStruct[0].remoteMethod = getApplicationOptions
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      searchFormRef,
      getUploadUri,
      getUploadHeader,
      handleUpload,
      createUpload,
      ...toRefs(dataMap)
    }
  }
})
